export interface Actress {
  id: string;
  name: string;
  age: number;
  birthday: string | null;
  height: number;
  bust: number;
  waist: number;
  hip: number;
  cupSize: string;
  tags: string[];
  imageUrl: string;
  createdAt: string;
  debutAge: number | null;
  latestActiveAge: number | null;
}

export interface DmmWork {
  contentId: string;
  title: string;
  url: string;
  imageUrl: string;
  date: string;
  genres: string[];
  campaign: { title: string; start: string; end: string } | null;
  listPrice: number | null;
  minPrice: number | null;
}

export interface FeedItem {
  id: number;
  contentId: string;
  title: string;
  sampleUrl: string;
  imageUrl: string | null;
  thumbnailUrl: string | null;
  affiliateUrl: string | null;
  videoUrl: string | null;
  date: string | null;
  minPrice: number | null;
  listPrice: number | null;
  campaign: { title: string; start: string; end: string } | null;
  genres: string[];
  actress: {
    id: string;
    name: string;
    imageUrl: string | null;
    cupSize: string | null;
  };
  similarActresses: {
    id: string;
    name: string;
    imageUrl: string | null;
    cupSize: string | null;
    bust: number | null;
    waist: number | null;
    hip: number | null;
  }[];
}

export interface FilterState {
  search: string;
  bustRange: [number, number];
  waistRange: [number, number];
  hipRange: [number, number];
  cupSizes: string[];
  ageGroups: string[];
  ageType: "real" | "active";
  heightRange: [number, number];
  sortBy: "style" | "newest" | "youngest" | "bust" | "waist" | "hip";
  tags: string[];
}

export type BwhCategory = "bust" | "waist" | "hip";

export interface BwhRange {
  category: BwhCategory;
  min: number;
  max: number;
}

export const DEFAULT_FILTER: FilterState = {
  search: "",
  bustRange: [70, 120],
  waistRange: [50, 80],
  hipRange: [70, 110],
  cupSizes: ["E", "F", "G"],
  ageGroups: ["10s"],
  ageType: "active",
  heightRange: [140, 180],
  sortBy: "youngest",
  tags: [],
};

export const CUP_SIZES = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"];

export const AGE_GROUPS = [
  { label: "10代", value: "10s" },
  { label: "20代前半", value: "20s-early" },
  { label: "20代後半", value: "20s-late" },
  { label: "30代", value: "30s" },
  { label: "40代以上", value: "40s+" },
];

export const SORT_OPTIONS = [
  { label: "若い順", value: "youngest" },
  { label: "スタイル順", value: "style" },
  { label: "バストサイズ順", value: "bust" },
  { label: "くびれ順", value: "waist" },
  { label: "ヒップ順", value: "hip" },
  { label: "新着順", value: "newest" },
] as const;

export const BUST_RANGES = [
  { label: "80-85", min: 80, max: 85 },
  { label: "85-90", min: 85, max: 90 },
  { label: "90-95", min: 90, max: 95 },
  { label: "95-100", min: 95, max: 100 },
  { label: "100-105", min: 100, max: 105 },
  { label: "105+", min: 105, max: 130 },
];

export const WAIST_RANGES = [
  { label: "50-55", min: 50, max: 55 },
  { label: "55-60", min: 55, max: 60 },
  { label: "60-65", min: 60, max: 65 },
  { label: "65-70", min: 65, max: 70 },
  { label: "70+", min: 70, max: 100 },
];

export const HIP_RANGES = [
  { label: "80-85", min: 80, max: 85 },
  { label: "85-90", min: 85, max: 90 },
  { label: "90-95", min: 90, max: 95 },
  { label: "95-100", min: 95, max: 100 },
  { label: "100+", min: 100, max: 130 },
];
